var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoSearchResultsRobotWhite = function SvgNoSearchResultsRobotWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 135,
    height: 113,
    viewBox: "0 0 135 113"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-18.117 -8.197)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.909,
    cy: 114.756,
    fill: "#534B6E",
    rx: 53.766,
    ry: 6.44
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F70C54",
    d: "M55.453 13.819c10.051 7.574 12.023 21.91 4.404 32.021a22.9 22.9 0 0 1-11.323 8.06l-.03.01a5.42 5.42 0 0 1-.997 4.31 5.5 5.5 0 0 1-.68.749l.46 3.932a3.75 3.75 0 0 1 1.26 2.386l1.53 12.762a3.81 3.81 0 0 1-3.308 4.234 3.765 3.765 0 0 1-4.209-3.289l-1.528-12.761a3.8 3.8 0 0 1 .772-2.788l-.501-3.393a5.37 5.37 0 0 1-3.49-5.352 22.6 22.6 0 0 1-9.95-4.267c-10.052-7.574-12.024-21.91-4.405-32.021C31.078 8.3 45.402 6.245 55.453 13.819m-3.278 4.35c-7.663-5.774-18.583-4.206-24.392 3.502-5.808 7.708-4.305 18.637 3.357 24.412 7.663 5.774 18.584 4.206 24.392-3.502 5.809-7.708 4.305-18.638-3.357-24.412"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    transform: "translate(46.567 24.72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m69.817 70.521-2.298 14.51-28.849-4.569 2.299-14.51zm-23.98 4.702-3.09-.49-.493 3.11 3.09.489zm19.576 3.1-3.09-.49-.493 3.11 3.09.49zm-18.755-8.282-3.09-.49-.493 3.11 3.09.489zm19.576 3.1-3.091-.49-.492 3.11 3.09.49z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.606,
    height: 8.657,
    x: 71.456,
    y: 75.492,
    rx: 4.303
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.606,
    height: 8.657,
    y: 48.734,
    rx: 4.303
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.9 16.256 3.022.81-3.26 12.163-3.022-.81z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.84 19.5 82.623 22.138-1.629 6.082-82.623-22.14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.515 38.125 3.023.81-3.26 12.163-3.022-.81zm1.323-17.027L89.716 73.805l-72.548-19.44L31.29 1.66l72.548 19.44zM71.586 45.662c-2.482.004-4.496 1.72-4.5 4.214.949-.002.47-.012 1.044-.013.096-1.04.732-3.148 3.454-3.152s3.852 2.168 3.85 3.14c1.006 0 .632.067 1.006.011.042-2.562-2.373-4.204-4.854-4.2M48.968 24.049l-7.656-2.051a4.3 4.3 0 0 0-.763 1.534l-.013.05a4.303 4.303 0 0 0 8.312 2.227l.014-.05a4.3 4.3 0 0 0 .106-1.71m32.873 6.092a4.303 4.303 0 0 0-5.27 3.043l-.013.05a4.303 4.303 0 0 0 8.312 2.227l.014-.05a4.303 4.303 0 0 0-3.043-5.27"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.518,
    height: 3.148,
    x: 47.985,
    y: 86.51,
    rx: 1.574
  })))));
};
export default SvgNoSearchResultsRobotWhite;